import React from 'react'



const NutCart = ({name, value}) => {
  return (
    <div className='nutritionalValues-container-col'>
      <div className='nutCart'>
          <div className='nutCart-top'>{value}</div>
          <div className='nutCart-bottom'>{name}</div>
      </div>
    </div>
  )
}

const NutritionalValues = ({getItem}) => {
  return (
    <div className='nutritionalValues'>
      <div className='nutritionalValues-container'>
        {
          getItem?.nutritionalValues.map((nut,i) => (
            <NutCart key={i} name={nut?.value} value={nut?.name}/>
          ))
        }
      </div>
      {/* <div className='nutritionalValues-container'>
      <NutCart name={"Kalori(kcal)"} value={"492,93"}/>
      <NutCart name={"Kalori(kcal)"} value={"492,93"}/>
      <NutCart name={"Kalori(kcal)"} value={"492,93"}/>
      <NutCart name={"Kalori(kcal)"} value={"492,93"}/>
      <NutCart name={"Kalori(kcal)"} value={"492,93"}/>
      <NutCart name={"Kalori(kcal)"} value={"492,93"}/>
      </div> */}
    </div>
  )
}

export default NutritionalValues